import React from 'react';

import TableSkeletonShell from './TableSkeletonShell';

interface InstructorTableSkeletonProps {
  rowCount?: number;
}

const InstructorTableSkeleton: React.FC<InstructorTableSkeletonProps> = ({
  rowCount = 6
}) => <TableSkeletonShell rows={rowCount} columns={5} />;

export default InstructorTableSkeleton;
